import {get, post} from '@utils/baseRequest';
import {host} from '@utils/hostConf';
import {stores} from '../index';

// 查询用户是否领取过优惠券
export function queryReviceCouponRecord(data) {
  return get({url: `${host.goapi}datasync/Handler/QueryReviceCouponRecord`, data});
}

// 点评详情
export function querylistcomment(data) {
  return get({url: `${host.cplus}cgi-bin/comment/listcomment`, data});
}

// 点评详情后补领优惠券列表
export function queryCouponList(data) {
  return get({url: `${host.goapi}datasync/handler/QueryCouponList`, data});
}

// 点评详情后补领优惠券
export function reciveCouponNew(data) {
  return get({url: `${host.goapi}datasync/Handler/ReciveCoupon`, data});
}

// 删除评论
export function deleteDocComment(data) {
  return post({url: `${host.goapi}comment/handler/DeleteDocComment`, data});
}


